export const employmentOptions = [
  { value: "2", label: "Employed" },
  { value: "1", label: "Full time student" },
  { value: "0", label: "Unemployed" },
];
